module.exports = __webpack_public_path__ + "img/gongzhonghao.70dea7e5.jpg";